import React from 'react';
import { Navigate, Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { LayoutDashboard, LogOut, Package, Mail } from 'lucide-react';
import { Logo } from '../../Logo';
export function AdminLayout() {
  const {
    user,
    profile,
    loading,
    signOut
  } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-screen bg-[#F9F9F9] flex items-center justify-center" data-id="element-229">
        <span className="w-6 h-6 border-2 border-tealslate/30 border-t-tealslate rounded-full animate-spin" data-id="element-230" />
      </div>;
  }
  if (!user || profile?.role !== 'admin') {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-231" />;
  }
  return <div className="min-h-screen bg-[#F9F9F9] flex" data-id="element-232">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-[#E5E5E5] flex flex-col" data-id="element-233">
        <div className="p-6 border-b border-[#E5E5E5]" data-id="element-234">
          <Link to="/admin" className="flex items-center gap-3" data-id="element-235">
            <Logo className="w-8 h-8" data-id="element-236" />
            <span className="font-bold text-[#111111] tracking-tight" data-id="element-237">
              Admin
            </span>
          </Link>
        </div>
        <nav className="flex-1 p-4 space-y-1" data-id="element-238">
          <Link to="/admin" className={`flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium transition-colors ${location.pathname === '/admin' ? 'bg-[#F0F4F8] text-tealslate' : 'text-[#5A5A5A] hover:bg-[#F9F9F9] hover:text-[#111111]'}`} data-id="element-239">
            <LayoutDashboard className="w-5 h-5" data-id="element-240" />
            Dashboard
          </Link>
          <Link to="/admin/orders" className={`flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium transition-colors ${location.pathname.startsWith('/admin/orders') ? 'bg-[#F0F4F8] text-tealslate' : 'text-[#5A5A5A] hover:bg-[#F9F9F9] hover:text-[#111111]'}`} data-id="element-241">
            <Package className="w-5 h-5" data-id="element-242" />
            Orders
          </Link>
          <Link to="/admin/newsletter" className={`flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium transition-colors ${location.pathname.startsWith('/admin/newsletter') ? 'bg-[#F0F4F8] text-tealslate' : 'text-[#5A5A5A] hover:bg-[#F9F9F9] hover:text-[#111111]'}`} data-id="element-243">
            <Mail className="w-5 h-5" data-id="element-244" />
            Newsletter
          </Link>
        </nav>
        <div className="p-4 border-t border-[#E5E5E5]" data-id="element-245">
          <button onClick={() => signOut()} className="flex items-center gap-3 px-4 py-3 w-full rounded-md text-sm font-medium text-[#5A5A5A] hover:bg-[#F9F9F9] hover:text-[#111111] transition-colors" data-id="element-246">
            <LogOut className="w-5 h-5" data-id="element-247" />
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto" data-id="element-248">
        <Outlet data-id="element-249" />
      </main>
    </div>;
}